module.exports = __webpack_public_path__ + "static/WEDDING E&M-56-f56619480997f0b51309f8f076c40b57.jpg";